import React from "react";
import DashboardBody from "./components/DashboardBody";
import OpdServedChart from "./components/sections/OpdServedChart";
import useHospitalDashboardController from "./controllers/useHospitalDashboardController";
import { rangeOptions } from "./constants/rangeOptions";
import "./HospitalDashboard.css";

const HospitalDashboard = () => {
  const {
    loading,
    errorMessage,
    hospitalName,
    range,
    fromDate,
    toDate,
    selectedRangeLabel,
    selectedPeriodLabel,
    customerVisitSearch,
    filteredVisits,
    opdVisits,
    insights,
    filteredCustomerVisitRows,
    setRange,
    setFromDate,
    setToDate,
    setCustomerVisitSearch,
    resetFilters,
  } = useHospitalDashboardController();

  return (
    <div className="hospital-dashboard">
      <div className="dashboard-hero">
        <div className="d-flex justify-content-between align-items-start gap-2 flex-wrap">
          <div>
            <h1>{hospitalName}</h1>

            <h6 style={{ margin: "1rem 0" }}>Hospital Insights Dashboard</h6>
            <p className="dashboard-subtitle mb-0">
              Real-time visit analytics from BookingConsultation
            </p>
            <p className="dashboard-subtitle mb-0">
              Updated on {new Date().toLocaleString("en-IN")}
            </p>
          </div>
        </div>

        <OpdServedChart opdVisits={opdVisits} />
      </div>

      <div className="dashboard-hero" style={{ marginTop: "1rem" }}>
        <div className="dashboard-insights-heading">
          <div className="dashboard-info-pills mt-2">
            <span className="dashboard-pill">Range: {selectedRangeLabel}</span>
            <span className="dashboard-pill">
              Records: {filteredVisits.length}
            </span>
          </div>
        </div>

        <div className="filters-panel">
          <div className="dashboard-filter-grid">
            <div className="dashboard-filter-field">
              <label className="mb-1" htmlFor="dashboard-range">
                Time Range
              </label>
              <select
                id="dashboard-range"
                className="form-select"
                value={range}
                onChange={(e) => setRange(e.target.value)}
              >
                {rangeOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>

            {range === "custom" ? (
              <>
                <div className="dashboard-filter-field">
                  <label className="mb-1" htmlFor="dashboard-from-date">
                    From Date
                  </label>
                  <input
                    id="dashboard-from-date"
                    type="date"
                    className="form-control"
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                  />
                </div>

                <div className="dashboard-filter-field">
                  <label className="mb-1" htmlFor="dashboard-to-date">
                    To Date
                  </label>
                  <input
                    id="dashboard-to-date"
                    type="date"
                    className="form-control"
                    value={toDate}
                    onChange={(e) => setToDate(e.target.value)}
                  />
                </div>
              </>
            ) : (
              <div className="dashboard-filter-field dashboard-filter-period">
                <div className="mb-1">Selected Period</div>
                <input
                  id="dashboard-selected-period"
                  type="text"
                  className="form-control dashboard-filter-readonly"
                  value={selectedPeriodLabel}
                  readOnly
                />
              </div>
            )}

            <div className="dashboard-filter-action">
              <button className="btn btn-primary w-100" onClick={resetFilters}>
                Reset
              </button>
            </div>
          </div>
        </div>
      </div>

      <DashboardBody
        loading={loading}
        errorMessage={errorMessage}
        filteredVisits={filteredVisits}
        insights={insights}
        customerVisitSearch={customerVisitSearch}
        setCustomerVisitSearch={setCustomerVisitSearch}
        filteredCustomerVisitRows={filteredCustomerVisitRows}
      />
    </div>
  );
};

export default HospitalDashboard;
